import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import { initializeLocalization } from "./shared/localization"
import { initializeTheme } from "./shared/theme"
import WorkbenchController from "./workbench/controller"
import { installAnalyticsLifecycle } from "./workbench/analytics"

declare global {
  interface Window {
    Stimulus: Application
  }
}

const application = Application.start()

application.debug = false
application.register("workbench", WorkbenchController)
window.Stimulus = application
installAnalyticsLifecycle()

let cleanupTheme: (() => void) | null = null
let cleanupLocalization: (() => void) | null = null

function initializePreferences(): void {
  cleanupTheme?.()
  cleanupLocalization?.()
  cleanupTheme = initializeTheme(document, window)
  cleanupLocalization = initializeLocalization(document, window)
  document.dispatchEvent(new CustomEvent("formatloom:locale-change", {
    detail: { locale: document.documentElement.dataset.locale },
  }))
}

document.addEventListener("turbo:load", initializePreferences)
initializePreferences()

export { application }
